import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Message } from 'primeng/primeng';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { ProductTarifService } from '../product-tarif.service'
import { TarifNameService } from '../../tarifs/tarif-name.service'

@Component({
  selector: 'app-product-tarif-crud',
  templateUrl: './product-tarif-crud.component.html',
  styleUrls: ['./product-tarif-crud.component.css'],
  providers: [
              ProductTarifService,
              TarifNameService
            ]
  // encapsulation: ViewEncapsulation.None
})
export class ProductTarifCrudComponent implements OnInit {

   tarif_name_id: any= null;
   tariff_id: any= null;
   msgs: Message[] = [];
   button_caption: string ="Сохранить";
   button_icon:string ="fa fa-save";
   criteriya:any[]=[];
   interval:any[]; 
   calculation_interval:string;
   criteriaPanel:boolean = false;
   calculationIntervalPanel:boolean = false;
   available:boolean = true;
   is_accumulated_bonus : number = 0;
   is_percentage:number=0;
   criteria_type:number=0;
   notCriteriyaValue: any;
   selectedValue: any;
   tarifName:any;
   loading: boolean = false;
   productTarif: any;

  constructor(
              private location: Location,
              private productTarifService: ProductTarifService,
              private tarifNameService: TarifNameService,
              private activatedRoute: ActivatedRoute
              ) { 

         this.selectedValue = 1; 
         this.interval= [
                         {label: '30 дней',value: 30},
                         {label: '60 дней',value: 60},
                         {label: '90 дней',value: 90},
                         {label: '120 дней',value: 120},
                         {label: '150 дней',value: 150},
                         {label: '180 дней',value: 180}
                         ];
         activatedRoute.params.subscribe(params=>{this.tariff_id=params['tariff_id'];this.tarif_name_id=params['tarif_name_id']});
         

         if(this.tarif_name_id){
            this.tarifNameService.getTarifNameById(this.tarif_name_id).subscribe(response=>{ this.productTarif.tariff_name=response['data'];})
         }

         if(this.tariff_id){
           this.loading = true;
           this.productTarifService.getProductTarifById(this.tariff_id).subscribe(response=>{
                this.productTarif =  response['data']; 
                this.onIsAccumulatedBonus( this.productTarif.is_accumulated_bonus);
                if(this.productTarif.is_criteria){
                  this.criteriya = this.productTarif.value; 
                  this.onIsCriteriya(this.productTarif.is_criteria); 
                }else{
                  this.productTarif.is_percentage = this.productTarif.value.is_percentage;   
                  this.productTarif.withoutCriteriyavalue = this.productTarif.value.value;
                }
                this.loading = false;
              });
         }

  }

  ngOnInit() {

    this.tarifName={};

    this.productTarif = {
      tariff_name :	[],
      name: "",
      product_count :       	0,
      is_accumulated_bonus: false,
      date_from: "",
      date_to: "",
      is_criteria: false,
      value: [] ,	
      withoutCriteriyavalue: 0,
      is_percentage: 0,
      available:true
    }

  }  

  addCriteriya(from,to,value){
    this.notCriteriyaValue="";
    this.criteriya.push({index:(this.criteriya.length), criteriya_type: this.criteria_type,from: from.value, to: to.value, value: value.value,is_percentage: 1})
  }

  deleteCriteriyaItem(index){
    this.criteriya.splice(index,1);
    this.criteriya=this.criteriya.map((value,index)=>{value.index=index; return value;});
  }

  onIsAccumulatedBonus(value){
    this.is_accumulated_bonus = value==true ? 1 : 0; 
    this.calculationIntervalPanel = value;
  }

  onIsPercentage(value){
    this.is_percentage=value==true ? 1 : 0;
  }


  onIsCriteriya(value){
     this.criteriaPanel = value;
  }

  onCriteriyaType(value){
    this.criteria_type = value;
  }
  
  backClicked() {
        this.location.back();
  }

  save(form: NgForm){

    form['value'].value=[];
      
    if(!this.productTarif.is_criteria){
      form['value'].value={ value:this.productTarif.withoutCriteriyavalue, is_percentage: this.productTarif.is_percentage} ;
    }else{
      form['value'].value = this.criteriya.map(value=>{return {criteria_type: this.criteria_type,from: value.from, to: value.to, value: value.value,is_percentage: 1}});
    }
    form['value'].is_accumulated_bonus=this.productTarif.is_accumulated_bonus;
    form['value'].is_criteria=this.productTarif.is_criteria;
    form['date_from']=this.productTarif.date_from;
    form['date_to']=this.productTarif.date_to;

    if(this.tarif_name_id){
      form['value'].tariff_name_id = this.tarif_name_id;  
      this.productTarifService.createProductTarif(form['value']).subscribe(response=>{
        this.msgs.push({severity:'success', summary:'Сообщение', detail: "Успешно добавлено"});
        this.criteriya=[];
        console.log(response)
      });
      
    }else if(this.tariff_id){
      form['value'].tariff_name_id = this.productTarif.tariff_name.id;  
      this.productTarifService.updateProductTarif(form['value'],this.tariff_id).subscribe(response=>{
        this.msgs.push({severity:'success', summary:'Сообщение', detail: "Успешно изменено"});
        this.criteriya=[];
        console.log(response)
      });
      
    }

   

      console.log(form.value);
  }

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/product_tarifs/product-tarif-crud/product-tarif-crud.component.ts